import { render, staticRenderFns } from "./landing_page.vue?vue&type=template&id=6ac00c71&scoped=true"
import script from "./landing_page.vue?vue&type=script&lang=js"
export * from "./landing_page.vue?vue&type=script&lang=js"
import style0 from "./landing_page.vue?vue&type=style&index=0&id=6ac00c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac00c71",
  null
  
)

export default component.exports